import type { ButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';

import * as React from 'react';
import { Xmark } from 'iconoir-react';

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(
  function CloseButton(props, ref) {
    return (
      <ChakraIconButton
        variant="ghost"
        rounded="full"
        borderWidth="1px"
        borderColor="border"
        color="fg.muted"
        aria-label="Close"
        ref={ref}
        _hover={{ bg: 'bg.muted', color: 'fg' }}
        {...props}
      >
        {props.children ?? <Xmark width={16} height={16} />}
      </ChakraIconButton>
    );
  }
);
